import styled, { css } from 'styled-components'
import {
  primaryColor,
  saleAlternativeColor,
  strikePriceGreyColor,
} from 'uiComponents/constants/colors'
import {
  fontFamilyPrimary,
  fsXXS,
  fwMediumBold,
} from 'uiComponents/constants/typography'

interface IProps {
  striked?: boolean
  highlight?: boolean
  $fontSize?: string
}

const TinyText = styled.span<IProps>`
  ${fontFamilyPrimary};
  ${fwMediumBold};
  color: ${primaryColor};
  font-size: ${({ $fontSize }) => $fontSize || `${fsXXS}px`};
  line-height: 1.4em;

  ${({ highlight, striked }) =>
    highlight &&
    !striked &&
    css`
      color: ${saleAlternativeColor};
    `};

  ${({ highlight, striked }) =>
    !highlight &&
    striked &&
    css`
      color: ${strikePriceGreyColor};
      text-decoration: line-through;
    `};
`

export default TinyText
